import { render, staticRenderFns } from "./CarePlanTable.vue?vue&type=template&id=60350a0c"
import script from "./CarePlanTable.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CarePlanTable.vue?vue&type=script&charset=utf-8&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports